/*

THIS IS THE COMPONENT THAT WILL BE USED TO RENDER THE COMPONENTS
- LEFT PANEL
- RIGHT PANEL

*/


import React from 'react';
import './AppContent.css';
import LeftPanel from '../LeftPanel/LeftPanel';
import RightPanel from '../RightPanel/RightPanel';
import { APP_TYPE, ZENPAY, SCHEDULER } from '../../constants/AppConstants';

const AppContent = (props) => {
  return (
    <div className={APP_TYPE === ZENPAY ? "AppContent" : "AppContentScheduler"}>
      <LeftPanel appConfigLoaded={props.appConfigLoaded} />
      {
        APP_TYPE === ZENPAY ?
        <RightPanel />
        :
        null
      }
      
    </div>
  )
}

export default AppContent;
